import React from "react";
import { DragDropContext, Droppable, DropResult } from "react-beautiful-dnd";
import { EnhancedTableBody } from "../EnhancedTableBody";
import { getReorderedItems } from "../../helpers/getReorderedItems";

import { SelectQuestionsTableBodyRow } from "./SelectQuestionsTableBodyRow";

import { IProps } from "./SelectQuestionsTable";
import useAuth from "../../routes/login/AuthContext";
import { useRetainAnswerToggle } from "../../hooks/useRetainAnswerToggle";

interface IExtendedProps extends IProps {
  setData: (question: any) => void;
  editDisabled: boolean;
  onSave: any;
}

export const SelectQuestionsTableBody: React.FC<IExtendedProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const {toggleRetainAnswer, isLoading} = useRetainAnswerToggle( props.onSave);
  const onDragEnd = ({ destination, source }: DropResult) => {
    if (destination?.index === source.index) {
      return;
    }

    props.onReorder({
      type: "SELECT",
      items: getReorderedItems({
        newIndex: destination?.index,
        oldIndex: source.index,
        items: props.questions,
      }),
    });
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="selectQuestions" isDropDisabled={isSuperAdminRead()}>
        {(provided) => (
          <EnhancedTableBody
            {...provided.droppableProps}
            colSpan={5}
            ref={provided.innerRef}
            isLoading={props.isLoading}
          >
            {props.questions.map((question, idx) => (
              <SelectQuestionsTableBodyRow
                idx={idx}
                key={question.id}
                showTagColumn={props.showTagColumn}
                handleEdit={() => props.setData(question)}
                handleDelete={() => props.onRemove(question)}
                editDisabled={props.editDisabled}
                {...question}
                toggleRetainAnswer={() => toggleRetainAnswer(question)}
                isLoading={isLoading}
              />
            ))}
            {Boolean(props.questions.length) && provided.placeholder}
          </EnhancedTableBody>
        )}
      </Droppable>
    </DragDropContext>
  );
};
